
    import _ from 'lodash';
    import {Component, Vue, Watch} from 'vue-property-decorator';
    import { ApiRepository } from '@/api';
    import InputText from '@/components/form/Input-text.vue';
    import Layout from '@/components/layout/Layout.vue';
    import Table from '@/components/table/Table.vue';
    import { IApplicationsCount } from "@/models/ApplicationsCount";
    import router from "@/router";

    @Component({
        components: {
            InputText,
            Layout,
            Table
        },
    })

    export default class PartnerShow extends Vue {
        private partner: any = {
            applications: [],
            cardRange: {
                from: null,
                to: null,
                cardNumbersFromList: false
            }
        };
        private keys = {
            id: '#',
            name: 'Meno',
            surname: 'Priezvisko',
            status: 'Stav'
        };
        private links = [
            {
                url: '/ziadosti/:param:',
                image: require('@/assets/image/edit.svg'),
            },
        ];
        private applicationsCount: IApplicationsCount = {
            new: 0,
            approved: 0,
            cancelled: 0,
            denied: 0
        };

        // toto funguje tak, ze ak je v stlpci s nazvom 'status' hodnota 'new', tak sa tam priradia prislusne classy
        private customColumnClass = {
            'status': {
                'new': {
                    'text-blue': true,
                    'font-bold': true
                },
                'approved': {
                    'text-green': true,
                    'font-bold': true
                },
                'denied': {
                    'text-red': true,
                    'font-bold': true
                },
                'cancelled': {
                    'text-gray': true,
                    'font-bold': true
                }
            }
        };

        private partnerCardNrsFile = null;

        public async mounted() {
            this.partner = await ApiRepository.getPartner(this.$route.params.partner);

            if (!this.partner.cardRange) {
                this.partner.cardRange = {
                    from: null,
                    to: null,
                    cardNumbersFromList: false
                };
            }

            this.getApplicationsCount();
        }

        private orderedLogs() {
            return _.orderBy(this.partner.logs, 'createdAt', 'desc');
        }

        private getApplicationsCount() {
            this.partner.applications.forEach((application: any) => {
                if (application.status === 'new') {
                    this.applicationsCount.new++;
                } else if (application.status === 'approved') {
                    this.applicationsCount.approved++;
                } else if (application.status === 'cancelled') {
                    this.applicationsCount.cancelled++;
                } else if (application.status === 'denied') {
                    this.applicationsCount.denied++;
                }
            });
        }

        private async updatePartner(event: any) {
            event.preventDefault();

            let from = this.partner.cardRange.from;
            let to = this.partner.cardRange.to;
            let cardNumbersFromList = this.partner.cardRange.cardNumbersFromList;

            if (!from && !to) {
                from = '0';
                to = '0';
            }

            await ApiRepository.putPartnerCardRange(this.$route.params.partner, {
                from: from ? parseInt(from) : null,
                to: to ? parseInt(to) : null,
                cardNumbersFromList: cardNumbersFromList
            });

            if (this.partnerCardNrsFile) {
                await ApiRepository.postImportPartnerCardNumbers(this.$route.params.partner, {
                    upload: this.partnerCardNrsFile
                });
            }
        }

        private async onChangeFile(event: any) {
            if (event.target.files[0]) {
                this.partnerCardNrsFile = event.target.files[0];
            }
        }

        private onClickCardNumbers() {
            router.push(`/partner/${this.$route.params.partner}/card-numbers`);
        }
    }
